import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

export default function TimeCart() {
  const { seconds_to_expire } = useSelector(state => state.sessioncustomer)
  const [currentTimeSeconds, setCurrentTimeSeconds] = useState(seconds_to_expire)

  useEffect(() => {
    setCurrentTimeSeconds(seconds_to_expire)
  }, [seconds_to_expire])

  const formmatedSeconds = useMemo(() => {
    // format second to mm:ss with two digits
    let minutes = Math.floor(currentTimeSeconds / 60)
    let seconds = currentTimeSeconds - minutes * 60
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }, [currentTimeSeconds])

  const interval = useEffect(() => {
    if (seconds_to_expire > 0) {
      const intervalId = setInterval(() => {
        setCurrentTimeSeconds(currentTimeSeconds => {
          if (currentTimeSeconds > 0) {
            return currentTimeSeconds - 1
          } else {
            clearInterval(interval)
            window.location.reload()
            return 0
          }
        })
      }, 1000)

      return () => {
        clearInterval(intervalId);
      };
    }

    return <></>
  }, [seconds_to_expire])

  if (seconds_to_expire === 0) {
    return <></>
  }

  return <>
    <div style={{
      color: '#fff',
      padding: 10,
      fontSize: '1.5rem',
      fontWeight: 'bold',
      height: 60,
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',
      width: 90,
      justifyContent: 'center'
    }} className='bg-primary'>
      {formmatedSeconds}
    </div>
  </>
}